<template>
  <div>
    <div class="i-layout-page-header">
      <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Row style="margin: 20px 0">
        <Col span="24">
          <h3>数据看板</h3>
        </Col>
      </Row>
      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">库存总数</div>
          <div><span class="statistics-text">{{ data.statistics.warehouse_inventory_total }}</span></div>
        </Col>
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">有效库存总数</div>
          <div><span class="statistics-text">{{ data.statistics.warehouse_inventory_effective_total }}</span></div>
        </Col>
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">入库总数</div>
          <div><span class="statistics-text">{{ data.statistics.warehouse_inventory_in_total }}</span></div>
        </Col>
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">出库总数</div>
          <div><span class="statistics-text">{{ data.statistics.warehouse_inventory_out_total }}</span></div>
        </Col>
      </Row>

      <Row style="margin: 20px 0">
        <Col>
          <h3>数据统计</h3>
        </Col>
      </Row>

      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="12">
          <div ref="inventoryInChart" style="width: 100%;height: 400px"></div>
        </Col>
        <Col span="12">
          <div ref="inventoryOutChart" style="width: 100%;height: 400px"></div>
        </Col>
      </Row>

      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="12">
          <div ref="landBaseInChart" style="width: 100%;height: 400px"></div>
        </Col>
        <Col span="12">
          <div ref="landBaseOutChart" style="width: 100%;height: 400px"></div>
        </Col>
      </Row>

      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="24">
          <div style="margin-bottom: 20px;">
            <Button type="primary" @click="initEnvironmentChart(item.warehouse_id)" v-for="item in data.statistics_map.environment_data" style="margin-right: 10px;">{{item.warehouse_name}}</Button>
          </div>
          <div ref="environmentChart" style="width: 100%;height: 400px"></div>
        </Col>
      </Row>

    </Card>

  </div>
</template>

<style>
.statistics-text{
  font-size: 24px;
}
</style>
<script>
import {dataVisualizationApi} from '@/api/warehouse/warehouseDataVisualization'
import * as echarts from 'echarts';

export default {
  name: 'warehouseDataVisualization',
  inject: ['reload'],
  data() {
    return {
      inventoryInChart: null,
      inventoryOutChart: null,
      landBaseInChart: null,
      landBaseOutChart: null,
      environmentChart: null,
      data: {
        statistics: {
          warehouse_inventory_total: 0,
          warehouse_inventory_effective_total: 0,
          warehouse_inventory_in_total: 0,
          warehouse_inventory_out_total: 0,
        },
        statistics_map: {
          warehouse_inventory_in: {
            month: [],
            count: [],
          },
          warehouse_inventory_out: {
            month: [],
            weight: [],
          },
          land_base_in: {
          },
          land_base_out: {
          },
          environment_data: [],
        }
      },
    }
  },

  created() {

  },

  mounted() {
    this.loadData()
  },

  beforeDestroy() {
    if (this.inventoryInChart) this.inventoryInChart.dispose();
    if (this.inventoryOutChart) this.inventoryOutChart.dispose();
    if (this.landBaseInChart) this.landBaseInChart.dispose();
    if (this.landBaseOutChart) this.landBaseOutChart.dispose();
    if (this.environmentChart) this.environmentChart.dispose();
  },

  methods: {
    loadData() {
      dataVisualizationApi().then(res => {
        if (res.code === 200) {
          this.data = res.data
          this.initInventoryInChart()
          this.initInventoryOutChart()
          this.initLandBaseInChart()
          this.initLandBaseOutChart()
          this.initEnvironmentChart()
        }else{
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 入库折线图
    initInventoryInChart() {

      // 初始化echarts实例
      this.inventoryInChart = echarts.init(this.$refs.inventoryInChart);

      // 指定图表的配置项和数据
      const option = {
        // 标题
        title: {
          text: '入库月趋势 (近6个月)',
          x: 'center',
          padding: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // 图例
        legend: {
          padding: 10,
          right: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // x轴文字
        xAxis: {
          type: 'category',
          data: this.data.statistics_map.warehouse_inventory_in.month,
        },
        // y轴的文字
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              return value + '单';
            }
          }
        },
        // 折线
        series: [{
          // 数据
          data: this.data.statistics_map.warehouse_inventory_in.count,
          // 类型
          type: 'line',
          // 内容
          name: '入库单数',
          // 样式
          itemStyle: {
            normal: {
              // 点颜色
              color: '#478bee',
              // 线颜色
              lineStyle: {
                color: '#47c16a'
              }
            }
          },
          // 显示数据
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: function (params) {
              return params.value + '单';
            }
          },
        }],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.inventoryInChart.setOption(option);

    },

    // 出库折线图
    initInventoryOutChart(){

      // 初始化echarts实例

      this.inventoryOutChart = echarts.init(this.$refs.inventoryOutChart);

      // 指定图表的配置项和数据
      const option = {
        // 标题
        title: {
          text: '出库月趋势 (近6个月)',
          x: 'center',
          padding: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // 图例
        legend: {
          padding: 10,
          right: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // x轴文字
        xAxis: {
          type: 'category',
          data: this.data.statistics_map.warehouse_inventory_out.month,
        },
        // y轴的文字
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              return value + '单';
            }
          }
        },
        // 折线
        series: [{
          // 数据
          data: this.data.statistics_map.warehouse_inventory_out.count,
          // 类型
          type: 'line',
          // 内容
          name: '出库单数',
          // 样式
          itemStyle: {
            normal: {
              // 点颜色
              color: '#478bee',
              // 线颜色
              lineStyle: {
                color: '#47c16a'
              }
            }
          },
          // 显示数据
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: function (params) {
              return params.value + '单';
            }
          },
        }],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.inventoryOutChart.setOption(option);
    },

    // 基地入库扇形图
    initLandBaseInChart() {
      // 类别扇形图

      // 初始化扇形图实例
      this.landBaseInChart = echarts.init(this.$refs.landBaseInChart);

      // 检查类型数据是否存在且不为空
      if (this.data.statistics_map.land_base_in && this.data.statistics_map.land_base_in.length > 0) {
        // 准备扇形图数据
        const data = this.data.statistics_map.land_base_in.map(item => ({
          name: item.land_base_name || '未知',
          value: item.count || 0,
        }));

        // 指定图表的配置项和数据
        const option = {
          // 标题
          title: {
            text: '基地入库分布',
            x: 'center',
            padding: 10,
            textStyle: {
              'color': '#516b91'
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            textStyle: {
              color: '#516b91'
            }
          },
          series: [
            {
              name: '分布情况',
              type: 'pie',
              radius: '60%',
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center',
                formatter: function (params) {
                  return params.name + ': ' + params.value + '单';
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: data
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.landBaseInChart.setOption(option);
      }


    },

    // 基地出库扇形图
    initLandBaseOutChart() {
      // 类别扇形图

      // 初始化扇形图实例
      this.landBaseOutChart = echarts.init(this.$refs.landBaseOutChart);

      // 检查类型数据是否存在且不为空
      if (this.data.statistics_map.land_base_out && this.data.statistics_map.land_base_out.length > 0) {
        // 准备扇形图数据
        const data = this.data.statistics_map.land_base_out.map(item => ({
          name: item.land_base_name || '未知',
          value: item.count || 0,
        }));

        // 指定图表的配置项和数据
        const option = {
          // 标题
          title: {
            text: '基地出库分布',
            x: 'center',
            padding: 10,
            textStyle: {
              'color': '#516b91'
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            textStyle: {
              color: '#516b91'
            }
          },
          series: [
            {
              name: '分布情况',
              type: 'pie',
              radius: '60%',
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center',
                formatter: function (params) {
                  return params.name + ': ' + params.value + '单';
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: data
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.landBaseOutChart.setOption(option);
      }


    },

    // 环境设备温湿度柱状图
    initEnvironmentChart(warehouseId = 0) {
      // 初始化柱状图
      this.environmentChart = echarts.init(this.$refs.environmentChart);

      // 获取数据
      // 循环this.data.statistics_map.environment_data
      let data = {
        warehouse_name: '',
        date: [],
        temperature_log: [],
        humidity_log: []
      };
      if (warehouseId === 0){
        data = this.data.statistics_map.environment_data[0];
      }else{
        this.data.statistics_map.environment_data.forEach((item, index) => {
          if (item.warehouse_id === warehouseId) {
            data = item;
          }
        })
      }

      // 配置新柱状图数据和样式
      const option = {
        title: {
          text: data.warehouse_name + ' 环境设备记录 (最新12条)',
          x: 'center',
          padding: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['温度', '湿度'], // 图例的名称需要和 series 中的 name 对应
          top: 30, // 图例的位置，可以调整
        },
        xAxis: [
          {
            type: 'category',
            data: data.date,
          }
        ],
        yAxis: [
          {
            type: 'value',
            max: function (value) {
              // y轴最大值根据最大数值 四舍五入 十位取整
              return Math.ceil(value.max / 10) * 10 + 10;
            }
          }
        ],
        series: [
          {
            name: '温度',
            type: 'bar',
            data: data.temperature_log,
            // 设置显示数据
            label: {
              show: true,
              position: 'top',
              color: '#000',
              fontSize: 12,
              formatter: function (params) {
                return params.value + '℃';
              }
            },
          },
          {
            name: '湿度',
            type: 'bar',
            data: data.humidity_log,
            // 设置显示数据
            label: {
              show: true,
              position: 'top',
              color: '#000',
              fontSize: 12,
              formatter: function (params) {
                return params.value + '％';
              }
            },
          }
        ],
      };

      // 使用配置项和数据显示图表
      this.environmentChart.setOption(option);
    },

  }
}
</script>
